import isDemo from '@/lib/utils/is_demo';
import createFileFormData from '@/lib/utils/create_file_form_data';
import { httpPost, camelify } from '../rest';

export function ctor(httpPost, camelify, createFileFormData, isDemo) {
  return async function uploadPhoto(file, imageType) {
    let data;
    /* istanbul ignore if */
    if (isDemo()) {
      data = {
        photo_url:
          '../images/profile-photo.png',
      };
    } else {
      const formData = createFileFormData('photo', file);
      formData.append('photo_type', imageType);
      const response = await httpPost('/advisor_photos', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      data = response.data;
    }
    return camelify(data);
  };
}

const uploadPhoto = ctor(httpPost, camelify, createFileFormData, isDemo);

export default uploadPhoto;
